export const AppNameHeading = styled.h1`
    font-family: 'Segoe UI', 'Segoe UI Web (West European)', 'Segoe UI', -apple-system, BlinkMacSystemFont, Roboto,
        'Helvetica Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    font-size: 16px;
    font-weight: 600;
    outline: none;
    text-decoration: none;
    height: 46px;
    line-height: 46px;
    display: block;
    overflow: hidden;
    max-width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    border: 1px solid transparent;
    color: rgb(255, 255, 255) !important;
`;
